module.exports = __webpack_public_path__ + "static/media/keeping-in-touch.30de596d.png";